const state = {
    Items: {
        data: [],
        total: 0,
        pages: {
            page: 1,
            totalPage: 1,
            limit: 100,
            filter: {

            }
        },
    },
    Loadings: {
        list: false,
        detail: false,
        detailChecklist: false,
    },
    Item: null,
    Checklist: null
};

const getters = {
    Items: (state) => state.Items,
    Loadings: (state) => state.Loadings,
    Item: (state) => state.Item,
    Checklist: (state) => state.Checklist,
};

const actions = {
    async getItems({ commit }, params) {
        return new Promise((resolve, reject) => {
            commit('setLoadings', { key: "list", val: true });
            global.axios.get(`/api/issue-register`, { params: params })
                .then(response => {
                    response.data.data.pages = params
                    commit('setLoadings', { key: "list", val: false });
                    commit('setItems', response.data.data);
                    resolve(response.data.data);
                })
                .catch(error => reject(error));
        });
    },
    async updateStatusIssueRegisteratus({ commit }, params) {
        return new Promise((resolve, reject) => {
            let formData = new FormData();
            if(params.data.description) formData.append('description', params.data.description || '');
            if(params.data.status) formData.append('status', params.data.status);
            if(params.data.preset_actions) formData.append('preset_actions', params.data.preset_actions || '');
            if (params.data.photos) {
                for (var i = 0; i < params.data.photos.length; i++) {
                    let photo = params.data.photos[i];
                    formData.append('photos[' + i + ']', photo);
                }
            }

            if(params.data.is_action_taken) {
                formData.append('is_action_taken', params.data.is_action_taken || false);
            }

            if(params.data.action_taken_date_rectified) {
                formData.append('action_taken_date_rectified', params.data.action_taken_date_rectified || '');
            }

            if(params.data.action_taken_description) {
                formData.append('action_taken_description', params.data.action_taken_description || '');
            }
            
            if (params.data.action_taken_photos) {
                for (var i = 0; i < params.data.action_taken_photos.length; i++) {
                    let photo = params.data.action_taken_photos[i];
                    formData.append('upload_action_taken_photos[' + i + ']', photo);
                }
            }

            global.axios(`/api/issue-register/${params.id}`, {
                    method: "POST",
                    data: formData,
                    headers: {
                        Accept: "application/json",
                    },
                })
                .then(response => {
                    commit('updateItems', params);
                    resolve(response);
                })
                .catch(error => reject(error));
        });
    },
    async getItem({ commit }, params) {
        return new Promise((resolve, reject) => {
            commit('setLoadings', { key: "detail", val: true });
            global.axios.get(`/api/issue-register/${params}`)
                .then(response => {
                    commit('setLoadings', { key: "detail", val: false });
                    commit('setItem', response.data.data);
                    resolve(response.data.data);
                })
                .catch(error => reject(error));
        });
    },
    async Checklist({ commit }, params) {
        return new Promise((resolve, reject) => {
            commit('setLoadings', { key: "detailChecklist", val: true });
            global.axios.get(`api/contracts/${params.contract_id}/checklists/${params.checklist_id}`)
                .then(response => {
                    commit('setLoadings', { key: "detailChecklist", val: false });
                    commit('Checklist', response.data.data);
                    resolve(response.data.data);
                })
                .catch(error => reject(error));
        });
    },
    async exportItems({ commit }, params) {
        return new Promise((resolve, reject) => {
            global.axios.get(`api/issue-register/export`, { params: params })
                .then(response => {
                    resolve(response);
                })
                .catch(error => reject(error));
        });
    },
    deleteAttachmentsFollowUp({ commit }, params) {
        return new Promise((resolve, reject) => {
            global.axios(`/api/attachments`, {
                    method: "DELETE",
                    data: { ids: params.ids },
                    headers: {
                        Accept: "application/json",
                    },
                })
                .then(response => {
                    commit('deleteAttachmentsFollowUp', params)
                    resolve(response);
                })
                .catch(error => reject(error));
        });
    },
    async updateFollowUp({ commit }, params) {
        return new Promise((resolve, reject) => {
            let formData = new FormData();
            for (var i = 0; i < params.action.photos.length; i++) {
                let photo = params.action.photos[i];
                formData.append('photos[' + i + ']', photo);
            }
            formData.append('description', params.data.description);
            formData.append('remark_type', params.data.remark_type);
            formData.append('isfollowUp', params.isfollowUp);
            formData.append('key_of_list', params.data.key_of_list);
            formData.append('action_taken_date_rectified', params.action_taken_date_rectified || '');
            formData.append('action_taken_description', params.action_taken_description || '');
            global.axios(`/api/runsheet/remarks/${params.runsheet_id}`, {
                    method: "POST",
                    data: formData,
                    headers: {
                        Accept: "application/json",
                    },
                })
                .then(response => {
                    //
                })
        });
    },
    async updateActionTaken({ commit }, params) {
        return new Promise((resolve, reject) => {
            let formData = new FormData();
            formData.append('description', params.data.description || '');
            formData.append('user_timestamp', params.data.user_timestamp);
            for (var i = 0; i < params.data.photos.length; i++) {
                let photo = params.data.photos[i];
                formData.append('upload_action_taken_photos[' + i + ']', photo);
            }
            global.axios(`/api/issue-action-taken/${params.id}`, {
                    method: "POST",
                    data: formData,
                    headers: {
                        Accept: "application/json",
                    },
                })
                .then(response => {
                    resolve(response);
                })
                .catch(error => reject(error));
        });
    }
};

const mutations = {
    setItems(state, data) {
        data.pages.totalPage = Math.ceil(data.total / data.pages.limit);
        state.Items.data = data.items;
        state.Items.total = data.total;
        state.Items.pages = data.pages;
    },
    setLoadings(state, data) {
        state.Loadings[data.key] = data.val;
    },
    updateItems(state, data) {
        state.Items.data = state.Items.data.map(item => {
            if (item.id === data.id) {
                item.status = data.data.status
                item.notes = data.data.notes
            }
            return item
        });
    },
    setItem(state, data) {
        if(data && data.action_takens && data.action_takens.length) {
            data.action_taken_id = data.action_takens[0].id
            data.action_taken_date_rectified = data.action_takens[0].user_timestamp ? data.action_takens[0].user_timestamp : data.action_takens[0].updated_at
            data.action_taken_description = data.action_takens[0].description
            data.action_taken_photos = data.action_takens[0].attachments
        }
        state.Item = data
    },
    Checklist(state, data) {
        state.Checklist = data
    },
    deleteAttachmentsFollowUp(state, data) {
        //
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}